import './TableBefore.scss';
import { useEffect, useRef } from 'react';

export type TableBeforeProps = {
	isFilterActive: boolean;
	handleResetFilter: () => Promise<void>;
};

const TableBefore: React.FC<TableBeforeProps> = ({
	isFilterActive,
	handleResetFilter,
}) => {
	const mainDivRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (mainDivRef.current) {
			mainDivRef.current.hidden = false;
		}
	}, []);

	const handleAjax = () => {
		handleResetFilter();
	};

	return (
		<>
			<div className="library-page-text" ref={mainDivRef} hidden={true}>
				<div className="italics-text">
					<button
						className={
							'search-count-label link ' + (isFilterActive ? '' : 'invisible')
						}
						onClick={handleAjax}
					>
						<div className="resetContainer">
							<i className="py-2 fa fa-undo"></i>
							<div>
								<span id="reset" className="bold-text">
									Reset all
								</span>
							</div>
						</div>
					</button>
					<a
						className="proxyLinkContainer"
						href="#proxy"
						aria-labelledby="proxyvoting"
						data-final-url
					>
						<div className="selector Btn">
							<span className="bold-text" id="proxyvoting">
								Proxy Information
							</span>
						</div>
					</a>
				</div>
			</div>
		</>
	);
};

export default TableBefore;
